import Image from "next/image";
import { Props } from "./types";

const Checkbox = ({
  children,
  id,
  checked,
  value,
  className,
  checkboxTheme,
  checkboxFontSize,
  ...props
}: Props) => (
  <div className={`flex items-center ${className}`}>
    <div
      className={`relative flex-shrink-0 w-6 h-6 border rounded border-grey-400 transition duration-300 ease-in-out ${
        checkboxTheme === "light" ? "bg-white" : "bg-grey-800"
      } `}
    >
      <input
        type="checkbox"
        value={value}
        id={id}
        className="absolute z-10 w-full h-full opacity-0 cursor-pointer"
        {...props}
      />
      {checked && (
        <div className="w-4 h-4 cursor-pointer absolute-center-xy">
          <Image
            layout="fill"
            alt="check"
            src={checkboxTheme == "light" ? "/icons/check-blue.svg" : "/icons/check.svg"}
          />
        </div>
      )}
    </div>
    <label htmlFor={id} className="ml-4 text-sm md:text-lg font-normal md:leading-7 cursor-pointer">
      {children}
    </label>
  </div>
);

export default Checkbox;
